import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Row, Col, Table, Button } from 'react-bootstrap';
import { PositionGroupLog } from '../../data/PositionGroupLog/schemas/PositionGroupLog.schema';
import { formatYMDToDMY } from '../../modules/Common';

type Props = {
    isOpen?: boolean;
    onClose?: () => void;
    positionGroupLog?: PositionGroupLog[];
};

const ACTION_STYLES: Record<string, React.CSSProperties> = {
    added: { backgroundColor: '#d4edda', color: '#155724' },
    edit: { backgroundColor: '#d1ecf1', color: '#0c5460' },
    deleted: { backgroundColor: '#f8d7da', color: '#721c24' }
};

function PositionGroupLogModal(props: Props) {
    const { isOpen, onClose, positionGroupLog } = props;

    return (
        <Modal className="h-[90%] w-[98%] max-w-[1920px]" isOpen={isOpen} onClose={onClose}>
            <ModalHeader>
                <p className="text-base font-semibold">Authority Group Change Log</p>
            </ModalHeader>
            <ModalBody>
                <div style={{ overflowX: 'scroll' }} className="mt-2">
                    <Table className="table-bordered table-hover">
                        <thead>
                            <tr className="table-active thead-light text-nowrap text-center" style={{ width: '100%' }}>
                                <th>Time</th>
                                <th>Subject</th>
                                <th>Action</th>
                                <th>Object</th>
                            </tr>
                        </thead>
                        <tbody>
                            {positionGroupLog && positionGroupLog
                                .sort((a, b) => (a.created_on ?? '') < (b.created_on ?? '') ? 1 : -1)
                                .map((item, idx) => {
                                    const actionStyle = ACTION_STYLES[item.action ?? ''] ?? {};
                                    return (
                                        <tr key={idx} style={actionStyle}>
                                            <td>{formatYMDToDMY(item.created_on ?? '')}</td>
                                            <td>{item.created_by}</td>
                                            <td><b>{item.action}</b></td>
                                            <td>
                                                {item.details && item.details.map((detail, idy) => (
                                                    <React.Fragment key={idy}>
                                                        {detail.changeType === 'position_code' ? (
                                                            <Row className="show-grid align-items-center">
                                                                {item.action === 'added' && (
                                                                    <>
                                                                        <Col md="auto">add position code</Col>
                                                                        <Col md="auto"><b>{detail.authorityGroupId}</b></Col>
                                                                    </>
                                                                )}
                                                                {item.action === 'deleted' && (
                                                                    <>
                                                                        <Col md="auto">delete position code</Col>
                                                                        <Col md="auto"><b>{detail.authorityGroupId}</b></Col>
                                                                    </>
                                                                )}
                                                            </Row>
                                                        ) : detail.tab ? (
                                                            <Row className="show-grid align-items-center">
                                                                {item.action === 'added' && (
                                                                    <>
                                                                        <Col md="auto">add</Col>
                                                                        <Col md="auto"><b>{detail.parameterId}</b></Col>
                                                                        <Col md="auto">at</Col>
                                                                        <Col md="auto"><b>{detail.authorityGroupId}</b></Col>
                                                                        <Col md="auto">operator</Col>
                                                                        <Col md="auto"><b>{detail.operator}</b></Col>
                                                                        <Col md="auto">value</Col>
                                                                        <Col md="auto"><b>{detail.newValue}</b></Col>
                                                                    </>
                                                                )}
                                                                {item.action === 'edit' && detail.changeType === 'value' && (
                                                                    <>
                                                                        <Col md="auto">change value</Col>
                                                                        <Col md="auto"><b>{detail.parameterId}</b></Col>
                                                                        <Col md="auto">at</Col>
                                                                        <Col md="auto"><b>{detail.authorityGroupId}</b></Col>
                                                                        <Col md="auto">from</Col>
                                                                        <Col md="auto"><b>{detail.oldValue}</b></Col>
                                                                        <Col md="auto">to</Col>
                                                                        <Col md="auto"><b>{detail.newValue}</b></Col>
                                                                    </>
                                                                )}
                                                                {item.action === 'edit' && detail.changeType === 'operator' && (
                                                                    <>
                                                                        <Col md="auto">change operator</Col>
                                                                        <Col md="auto"><b>{detail.parameterId}</b></Col>
                                                                        <Col md="auto">at</Col>
                                                                        <Col md="auto"><b>{detail.authorityGroupId}</b></Col>
                                                                        <Col md="auto">from</Col>
                                                                        <Col md="auto"><b>{detail.oldValue}</b></Col>
                                                                        <Col md="auto">to</Col>
                                                                        <Col md="auto"><b>{detail.newValue}</b></Col>
                                                                    </>
                                                                )}
                                                                {item.action === 'deleted' && (
                                                                    <>
                                                                        <Col md="auto">delete</Col>
                                                                        <Col md="auto"><b>{detail.parameterId}</b></Col>
                                                                        <Col md="auto">at</Col>
                                                                        <Col md="auto"><b>{detail.authorityGroupId}</b></Col>
                                                                    </>
                                                                )}
                                                            </Row>
                                                        ) : null}
                                                    </React.Fragment>
                                                ))}
                                            </td>
                                        </tr>
                                    );
                                })}
                        </tbody>
                    </Table>
                </div>
            </ModalBody>
            <ModalFooter className="mt-auto flex justify-end gap-4 px-2">
                <Button onClick={() => onClose && onClose()} variant="outline-danger" size="sm">Close</Button>
            </ModalFooter>
        </Modal>
    );
}

export default PositionGroupLogModal;
